// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-voucher {
  border: 1px solid white;
  border-radius: 4px;
  padding: 10px;
  margin-top: 12px;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}
.list-voucher .action.delete {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 26px;
  cursor: pointer;
}
.list-voucher .action.delete {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 26px;
  cursor: pointer;
}
.list-voucher .voucher-image {
  width: 100px;
  display: inline-block;
  vertical-align: top;
  margin-top: 4px;
  box-sizing: border-box;
}
.list-voucher .voucher-details {
  display: inline-block;
  padding-left: 30px;
  vertical-align: top;
  width: calc(100% - 100px);
  box-sizing: border-box;
  overflow: hidden;
}
.list-voucher h1 {
  font-size: 18px;
  margin-bottom: 6px;
  margin-top: 0px;
}
.list-voucher label {
  font-weight: bold;
  width: 140px;
  display: inline-block;
}
.list-voucher .redeemed,
.list-voucher .claimed {
  color: green;
}
.list-voucher .not-claimed {
  color: red;
}
.list-voucher .not-redeemed {
  color: orange;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/list-voucher/list-voucher.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AACR;AAEI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAAR;AAGI;EACI,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAFR;AAMI;EACI,eAAA;EACA,kBAAA;EACA,eAAA;AAJR;AAOI;EACI,iBAAA;EACA,YAAA;EACA,qBAAA;AALR;AAQI;;EAEI,YAAA;AANR;AASI;EACI,UAAA;AAPR;AAUI;EACI,aAAA;AARR","sourcesContent":[".list-voucher {\n    border: 1px solid white;\n    border-radius: 4px;\n    padding: 10px;\n    margin-top: 12px;\n    overflow: hidden;\n    box-sizing: border-box;\n    position: relative;\n\n    .action.delete {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        font-size: 26px;\n        cursor: pointer;\n    }\n\n    .action.delete {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        font-size: 26px;\n        cursor: pointer;\n    }\n\n    .voucher-image {\n        width: 100px;\n        display: inline-block;\n        vertical-align: top;\n        margin-top: 4px;\n        box-sizing: border-box;\n    }\n\n    .voucher-details {\n        display: inline-block;\n        padding-left: 30px;\n        vertical-align: top;\n        width: calc(100% - 100px);\n        box-sizing: border-box;\n        overflow: hidden;\n        // border: 1px solid green;\n    }\n\n    h1 {\n        font-size: 18px;\n        margin-bottom: 6px;\n        margin-top: 0px;\n    }\n\n    label {\n        font-weight: bold;\n        width: 140px;\n        display: inline-block;\n    }\n\n    .redeemed,\n    .claimed {\n        color: green;\n    }\n\n    .not-claimed {\n        color: red;\n    }\n\n    .not-redeemed {\n        color: orange;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
